import { addHours, addMinutes, parseISO } from 'date-fns'
import { format, zonedTimeToUtc } from 'date-fns-tz'

const isValidStringDate = (value: string | Date) => {
  if (typeof value === 'string') {
    const parsedValue = value.trim()

    const timestamp = Date.parse(parsedValue)

    if (isNaN(timestamp) === false) {
      return true
    }

    return false
  }

  return value
}

export const formatDate = (
  value: string | Date,
  formatString?: string
): string => {
  if (!value || !isValidStringDate(value)) return value as string

  if (typeof value === 'string') {
    const parsedDate = parseISO(value)
    const znDate = zonedTimeToUtc(parsedDate, 'America/Sao_Paulo')
    const addedDate = addHours(znDate, 3)
    return format(addedDate, formatString || 'dd/MM/yyyy')
  }

  return format(value, formatString || 'dd/MM/yyyy')
}

export const getTimezonedIsoString = (date: string) => {
  const timezoneDiff = new Date().getTimezoneOffset()

  const timezonedDate = addMinutes(new Date(date), timezoneDiff).toISOString()

  return timezonedDate
}

export const parseDateForDatePicker = (
  dateString: string | null | undefined
): Date | null => {
  if (!dateString) return null

  // Parse the ISO string to get the date parts
  const date = new Date(dateString)

  // Use UTC methods to extract the date components, then create a local date
  // This prevents timezone conversion issues that cause the date to shift by one day
  // When the date comes as "2024-01-15T00:00:00.000Z", we want to show 2024-01-15,
  // not 2024-01-14 (which would happen if we use getDate() in UTC-3 timezone)
  const localDate = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate()
  )

  return localDate
}
